<template>
  <v-col class="mb-2" cols="12">
    <v-dialog v-model="showEditOptionDialog"
              max-width="500px">
      <v-card>
        <v-toolbar color="kbBlue" dark flat>
          <v-toolbar-title>
            {{ $t('general.editOption') }}
          </v-toolbar-title>

          <v-spacer/>

          <v-btn @click="closeEditOption()"
                 icon>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
            </v-col>
            <v-col cols="12">
              <v-text-field color="kbBlueDark"
                            :label="$t('general.value')"
                            v-model="editOptionValue.text">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-autocomplete color="kbBlueDark"
                              :items="getItemsDependencies(field.dependsOn)"
                              item-value="text"
                              :label="$t('general.dependence')"
                              v-if="isDependentOption"
                              v-model="editOptionValue.valueDependent">
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>

          <v-btn @click="closeEditOption()"
                 color="kbRed"
                 dark
                 text>
            {{ $t('general.cancel') }}
          </v-btn>

          <v-btn @click="submitEditOption()"
                 color="kbBlue"
                 dark>
            {{ $t('general.update') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card color="kbWhite">
      <v-toolbar flat color="rgba(66, 121, 214, 0.3)" dense>
        <v-spacer/>

        <v-btn icon
               text
               color="primary"
               v-if="index > 0"
               @click="upField">
          <v-icon>
            arrow_upward
          </v-icon>
        </v-btn>

        <v-btn icon
               text
               color="primary"
               v-if="index < form.fields.length - 1"
               @click="downField">
          <v-icon>
            arrow_downward
          </v-icon>
        </v-btn>

        <v-btn icon
               text
               color="primary"
               @click="deleteField(index)">
          <v-icon>
            clear
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field color="kbDarkBlueText"
                          :label="`${$t('general.name')} / ${$t('general.label')}`"
                          v-model="field.name">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select color="kbDarkBlueText"
                      :label="$t('general.type')"
                      v-model="field.type"
                      :items="typeFields">
              <template slot="item" slot-scope="data">
                <v-list-item-avatar>
                  <v-icon color="kbDarkBlueText">
                    {{data.item.icon}}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="kbDarkBlueText--text">
                    {{data.item.text}}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" v-if="field.type === 'dependent'">
            <v-select color="kbDarkBlueText"
                      :items="fields"
                      item-text="name"
                      item-value="_id"
                      :label="$t('general.fieldOnWhichItDepends')"
                      :rules="[field.dependsOn && field.dependsOn.name !== field.name || $t('general.theFieldMustNotBeTheSame')]"
                      v-model="field.dependsOn">
            </v-select>
          </v-col>

          <v-col  cols="12" sm="6" md="4" lg="3" v-if="validateField">
            <v-select color="kbDarkBlueText"
                      :label="$t('general.fieldLength')"
                      v-model="field.options.size"
                      :items="sizeFields">
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" v-if="field.type !== 'file-uploader' && field.type !== 'hidden'">
            <v-switch color="kbBlue"
                      :disabled="field.type === 'register-email' || field.type === 'register-phone' || field.type === 'register-name'"
                      :label="$t('general.required')"
                      v-model="field.isRequired">
            </v-switch>
          </v-col>

          <v-col cols="12" md="5" v-if="field.type === 'file-uploader'">
            <v-select color="kbDarkBlueText"
                      :label="$t('general.minFiles')"
                      v-model="field.options.fileQuantity"
                      :items="cantidadDeArchivos">
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row v-if="field.type === 'terms'">
          <v-col cols="12">
            <v-text-field color="kbDarkBlueText"
                          v-model="field.options.terms"
                          :label="$t('general.linkOfTermsAndConditions')">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field color="kbDarkBlueText"
                          v-model="field.options.dataHandling"
                          :label="$t('general.dataHandlingLink')">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="field.type === 'checkbox' || field.type === 'radio' || field.type === 'select'">
          <v-col cols="12">
            <v-text-field color="kbDarkBlueText"
                          :placeholder="$tc('general.option', 1)"
                          append-icon="add"
                          @keypress.enter="addItem()"
                          persistent-hint
                          prepend-icon="mdi-information"
                          @click:prepend="$emit('openHelpModal', 'simpleOptions')"
                          :hint="$t('general.pressEnterToAddOptionOrPasteFromAnExcel')"
                          @click:append="addItem()"
                          @paste="onPasteItem($event)"
                          v-model="optionValue">
            </v-text-field>

            <v-switch color="kbBlue"
                      :label="$t('general.includeOptionOthers')"
                      v-model="field.options.includeOthersOption">
            </v-switch>

            <v-data-table :headers="headersOptions"
                          :items="field.options.items">
              <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2"
                        @click="editOption(item, false)">
                  mdi-pencil
                </v-icon>

                <v-icon @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row v-if="field.type === 'dependent'">
          <v-col cols="12" sm="6">
            <v-text-field :label="$t('general.value')"
                          prepend-icon="mdi-information"
                          @click:prepend="$emit('openHelpModal', 'dependentOptions')"
                          v-model="dependentOption.text"
                          @paste="onPasteItemDependent">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete :items="getItemsDependencies(field.dependsOn)"
                            item-value="text"
                            :label="$t('general.dependence')"
                            v-model="dependentOption.valueDependent">
            </v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-btn block
                   @click="addDependentItem(dependentOption)"
                   color="kbBlue"
                   dark>
              {{ $t('general.addOptions') }}
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table :headers="headersDependantsOn"
                          :items="field.options.itemsDependents">
              <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2"
                        @click="editOption(item, true)">
                  mdi-pencil
                </v-icon>

                <v-icon @click="deleteDependentItem(item)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import uniqid from 'uniqid'
import _ from 'lodash'
export default {
  computed: {
    headersOptions () {
      return [
        { text: this.$t('general.option'), value: 'text' },
        { text: this.$t('general.actions'), align: 'right', value: 'actions' }
      ]
    },
    headersDependantsOn () {
      return [
        { text: this.$t('general.option'), value: 'text' },
        { text: this.$t('general.dependence'), value: 'valueDependent' },
        { text: this.$t('general.actions'), align: 'right', value: 'actions' }
      ]
    },
    validateField () {
      return this.field.type === 'text-field' ||
        this.field.type === 'select' ||
        this.field.type === 'phone' ||
        this.field.type === 'numeric'
    },
    typeFields () {
      const fields = [
        { icon: 'short_text', text: this.$t('general.shortTextField'), value: 'text-field' },
        { icon: 'format_align_left', text: this.$t('general.largeTextField'), value: 'textarea' },
        { icon: 'cloud_upload', text: this.$t('general.filesUpLoad'), value: 'file-uploader' },
        { icon: 'check_box', text: this.$t('general.verificationFields'), value: 'checkbox' },
        { icon: 'email', text: this.$t('general.email'), value: 'email' },
        { icon: 'label', text: this.$t('general.label'), value: 'label' },
        { icon: 'mdi-numeric', text: this.$t('general.numeric'), value: 'numeric' },
        { icon: 'mdi-relation-one-to-one-or-many', text: this.$t('general.dependent'), value: 'dependent' },
        { icon: 'arrow_drop_down_circle', text: this.$t('general.dropDownList'), value: 'select' },
        { icon: 'check_circle', text: this.$t('general.dataManagement'), value: 'terms' },
        { icon: 'mdi-eye-off', text: this.$t('general.hide'), value: 'hidden' },
        { icon: 'radio_button_checked', text: this.$t('general.multipleOption'), value: 'radio' },
        { icon: 'phone', text: this.$t('general.phone'), value: 'phone' }
      ]

      if (this.form.registerForm) {
        fields.unshift(
          { icon: 'email', text: `${this.$t('general.largeTextField')} - ${this.$t('general.email')}`, value: 'register-email', disabled: this.hasRegisterEmail },
          { icon: 'person', text: `${this.$t('general.largeTextField')} - ${this.$t('general.name')}`, value: 'register-name', disabled: this.hasRegisterName },
          { icon: 'phone', text: `${this.$t('general.largeTextField')} - ${this.$t('general.phone')}`, value: 'register-phone', disabled: this.hasRegisterPhone }
        )
      }

      return fields
    },

    cantidadDeArchivos () {
      return [
        { text: this.$t('general.NoRestrictions'), value: 0 },
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5 +', value: 5 }
      ]
    },
    sizeFields () {
      return [
        { text: this.$t('general.fullRow'), value: 'md12' },
        { text: this.$t('general.halfRow'), value: 'md6' }
      ]
    }
  },
  data: () => ({
    optionValue: '',
    dependentOption: {
      text: '',
      valueDependent: ''
    },
    editedIndex: -1,
    editOptionValue: {
      valueDependent: '',
      text: '',
      key: ''
    },
    optionType: '',
    isDependentOption: false,
    showEditOptionDialog: false
  }),
  methods: {
    submitEditOption () {
      if (this.isDependentOption) {
        Object.assign(this.field.options.itemsDependents[this.editedIndex], this.editOptionValue)
      } else {
        const option = {
          text: this.editOptionValue.text,
          key: this.editOptionValue.key
        }

        Object.assign(this.field.options.items[this.editedIndex], option)
      }
      this.closeEditOption()
    },
    addItem (value) {
      if (!value && !this.optionValue) return

      this.field.options.items.push({
        text: value || this.optionValue,
        key: uniqid()
      })

      this.optionValue = ''
    },
    addDependentItem (item) {
      if (!item.valueDependent || !item.text) return

      this.field.options.itemsDependents.push({
        valueDependent: item ? item.valueDependent || '' : '',
        text: item ? item.text || '' : '',
        key: uniqid()
      })

      this.dependentOption = {
        text: '',
        valueDependent: ''
      }
    },
    checkOptionsArray (options) {
      if (!options || Array.isArray(options)) {
        this.field.options = {
          items: [],
          itemsDependents: [],
          size: 'md12',
          row: false
        }
      }

      if (options && !options.itemsDependents) {
        this.$set(this.field.options, 'itemsDependents', [])
      }
    },
    closeEditOption () {
      this.editOptionValue = {
        valueDependent: '',
        text: '',
        key: ''
      }

      this.showEditOptionDialog = false
    },
    editOption (option, isDependentOption) {
      this.isDependentOption = isDependentOption || false
      this.selectedOption = option

      if (isDependentOption) {
        this.editedIndex = this.field.options.itemsDependents.indexOf(option)
      } else {
        this.editedIndex = this.field.options.items.indexOf(option)
      }

      this.editOptionValue = { ...option }
      this.showEditOptionDialog = true
    },
    getItemsDependencies (dependency) {
      if (!dependency) return []

      const dependentField = this.form.fields.find(item => {
        return item._id === dependency
      })

      if (!dependentField) return []

      if (dependentField.type === 'dependent') return dependentField.options.itemsDependents
      return dependentField.options.items
    },
    upField () {
      if (this.index > 0) {
        this.form.fields.splice(this.index - 1, 0, this.form.fields.splice(this.index, 1)[0])
      }
    },
    downField () {
      if (this.index < this.form.fields.length - 1) {
        this.form.fields.splice(this.index + 1, 0, this.form.fields.splice(this.index, 1)[0])
      }
    },
    deleteField (index) {
      this.form.fields.splice(index, 1)
    },
    deleteItem (item) {
      const index = this.field.options.items.indexOf(item)
      this.field.options.items.splice(index, 1)
    },
    deleteDependentItem (item) {
      const index = this.field.options.itemsDependents.indexOf(item)
      this.field.options.itemsDependents.splice(index, 1)
    },
    onPasteItem (event) {
      event.preventDefault()
      const clipboardData = event.clipboardData || window.clipboardData
      let pastedData = clipboardData.getData('Text')
      pastedData = pastedData.split('\n')

      pastedData.forEach(item => {
        this.addItem(item)
      })

      this.field.options.items = _.uniqBy(this.field.options.items, 'text')
    },
    onPasteItemDependent (event) {
      event.preventDefault()

      const clipboardData = event.clipboardData || window.clipboardData
      let pastedData = clipboardData.getData('Text')
      pastedData = pastedData.split('\n')

      pastedData.forEach(item => {
        const splitItem = item.split('\t')
        this.addDependentItem({
          text: splitItem[0],
          valueDependent: splitItem[1]
        })
      })

      this.field.options.itemsDependents = _.uniqBy(this.field.options.itemsDependents, 'text')
    }
  },
  props: ['field', 'fields', 'index', 'form', 'hasRegisterEmail', 'hasRegisterName', 'hasRegisterPhone'],
  watch: {
    'field.type' (value) {
      this.checkOptionsArray(this.field.options)

      if (value === 'register-phone' || value === 'register-email' || value === 'register-name') {
        this.field.isRequired = true
      }
    }
  }
}
</script>
